import * as angular from "angular";
import './newsfeed-show-links-dialog.css'


const newsfeedShowLinksDialog = {
    selector: 'showLinksDialog',
    bindings: {
        links: '<'
    },
    template: `
    <mw-mini-modal-dialog 
        class="mw-mini-modal-dialog mw-mini-modal--wide" 
        aria-label="" 
        layout="column" 
        flex
        title="{{$ctrl.$translate.instant('mw-newsfeeds--show-links-dialog__title')}}" 
        ok="Ok"
        on-ok="$ctrl.onDialogOk()">
        <mw-modal-content>
           <div class="mw-dialog__text-content">
           <div>
               <div class="showLinksBox">
                   <div class="showLinksText">
                       <div class="linksLabel">{{$ctrl.$translate.instant('RSS Link')}}</div>
                       <textarea class="linksFormat" rows="3" id="nllink_rss" >{{$ctrl.links.rsslink}}</textarea>
                   </div>
                   <div class="showLinksAction">
                        <md-button class="mw-button clipboard_btn" data-clipboard-target="#nllink_rss">{{$ctrl.$translate.instant('Copy')}}</md-button>
                   </div>
               </div>
               <div class="showLinksBox">
                   <div class="showLinksText">
                       <div class="linksLabel">{{$ctrl.$translate.instant('XML Link')}}</div>
                       <textarea class="linksFormat" rows="3" id="nllink_xml" >{{$ctrl.links.xmllink}}</textarea>
                   </div>
                   <div class="showLinksAction">
                        <md-button class="mw-button clipboard_btn" data-clipboard-target="#nllink_xml">{{$ctrl.$translate.instant('Copy')}}</md-button>
                   </div>
               </div>
               <div class="showLinksBox" ng-if="$ctrl.links.htmllink">
                   <div class="showLinksText">
                       <div class="linksLabel">{{$ctrl.$translate.instant('HTML Link')}}</div>
                       <textarea class="linksFormat" rows="3" id="nllink_html" >{{$ctrl.links.htmllink}}</textarea>
                   </div>
                   <div class="showLinksAction">
                        <md-button class="mw-button clipboard_btn" data-clipboard-target="#nllink_html">{{$ctrl.$translate.instant('Copy')}}</md-button>
                   </div>
               </div>
           </div>
        </mw-modal-content>
    </mw-mini-modal-dialog>
`,
    controller: null
};

class NewsfeedsShowLinksDialogComponent {
    $mdDialog: any;
    $translate: any;


    constructor($mdDialog, $translate) {
        'ngInject';
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        new Clipboard('.clipboard_btn')
    }

    onDialogOk() {
        this.$mdDialog.cancel();
    }

    copyLink() {

    }
}

newsfeedShowLinksDialog.controller = NewsfeedsShowLinksDialogComponent;

export {
    newsfeedShowLinksDialog,
    NewsfeedsShowLinksDialogComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsfeeds/newsfeed-show-links-dialog/newsfeed-show-links-dialog.component.ts
 **/